import React from "react";
import ThrillingActivitiesSection from "../../Sections/ThrillingActivitiesSection/Content";
const ThrillingActivitiePage = () => {
  return <ThrillingActivitiesSection />;
};

export default ThrillingActivitiePage;
